import styled from 'styled-components';
import { Tabs as AntdTab } from 'antd';

export const Tabs = styled(AntdTab)`
    .ant-tabs-nav {
        margin-left: 4%;
        margin-bottom: 0px;
    }
`;
